import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-base-100 w-96" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "join w-min" }

import { useKeycapStore, useToastStore } from "@/stores";
import IntegerInput from "@/components/utils/IntegerInput.vue";
import SettingsOption from "@/components/utils/SettingsOption.vue";
import ToggleOption from "@/components/settings/ToggleOption.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SettingsDialog',
  setup(__props) {

const toastSettings = useToastStore();
const kc = useKeycapStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("h1", {
      class: "title tooltip tooltip-bottom",
      "data-tip": "Change display style of keyboard keys"
    }, " Keycap style ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ToggleOption, {
        label: "Use Icons",
        tooltip: "Show key icons when possible",
        modelValue: _unref(kc).use_icons,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(kc).use_icons) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(ToggleOption, {
        label: "Use Mac Shift",
        tooltip: "Use Mac icon for the Shift key",
        modelValue: _unref(kc).use_mac_shift,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(kc).use_mac_shift) = $event)),
        disabled: !_unref(kc).use_icons
      }, null, 8, ["modelValue", "disabled"]),
      _createVNode(ToggleOption, {
        label: "Use Mac Ctrl",
        tooltip: "Use Mac Control icon for the Ctrl key",
        modelValue: _unref(kc).use_mac_ctrl,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(kc).use_mac_ctrl) = $event)),
        disabled: !_unref(kc).use_icons
      }, null, 8, ["modelValue", "disabled"]),
      _createVNode(ToggleOption, {
        label: "Use Mac GUI",
        tooltip: "Use Mac Command icon for GUI/Windows/Command/Super",
        modelValue: _unref(kc).use_mac_gui,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(kc).use_mac_gui) = $event)),
        disabled: !_unref(kc).use_icons
      }, null, 8, ["modelValue", "disabled"]),
      _createVNode(ToggleOption, {
        label: "Use Mac Alt",
        tooltip: "Use Mac Option icon for the Alt key",
        modelValue: _unref(kc).use_mac_alt,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(kc).use_mac_alt) = $event)),
        disabled: !_unref(kc).use_icons
      }, null, 8, ["modelValue", "disabled"]),
      _createVNode(ToggleOption, {
        label: "Short Key Names",
        tooltip: "Display short versions of key names when possible",
        modelValue: _unref(kc).short_names,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(kc).short_names) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(ToggleOption, {
        label: "Show Hold/Tap keys",
        tooltip: "Show Hold/Tap keys directly on the keycap",
        modelValue: _unref(kc).show_hold_tap,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(kc).show_hold_tap) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(ToggleOption, {
        label: "Use Hold/Tap icons",
        tooltip: "Show icons instead of 'H'/'T' when displaying Hold/Tap",
        modelValue: _unref(kc).use_hold_tap_icons,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(kc).use_hold_tap_icons) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(ToggleOption, {
        label: "Advanced Consumer keys",
        tooltip: "Enable all USB HID Consumer Page keys instead of only Media (some keys may not work)",
        modelValue: _unref(kc).advanced_consumer_keys,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(kc).advanced_consumer_keys) = $event))
      }, null, 8, ["modelValue"]),
      _cache[11] || (_cache[11] = _createElementVNode("h1", { class: "title" }, "Other", -1)),
      _createVNode(SettingsOption, {
        label: "Notification timeout",
        tooltip: "Time in seconds until notifications disappear. If set to 0 then notifications will disappear only when clicked."
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(IntegerInput, {
              class: "w-[9ch] input-sm join-item",
              min: 0,
              modelValue: _unref(toastSettings).timeout_sec,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(toastSettings).timeout_sec) = $event))
            }, null, 8, ["modelValue"]),
            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "join-item btn-input-unit btn-input-unit-sm" }, "sec", -1))
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})